export default __webpack_public_path__ + "static/media/allthecojy.904d053a.png";